import type { types } from "hls-parser";
export function getVariantPlaylistUrl(variantUri: string, masterPlaylistUrl: string) {
    if (/^https?:\/\//.test(variantUri)) return variantUri;
    return new URL(variantUri, masterPlaylistUrl).href;
}

export function sortVariantsByQuality(masterPlaylist: types.MasterPlaylist) {
    masterPlaylist.variants = masterPlaylist.variants.sort((a, b) => b.bandwidth - a.bandwidth);
}

export function getSubtitleTracks(masterPlaylist: Pick<types.MasterPlaylist, "variants">, masterPlaylistUrl: string) {
    return masterPlaylist.variants
        .flatMap(variant => (variant.subtitles ?? []).flatMap(subtitle => subtitle.uri
            ? [{...subtitle, _url: getVariantPlaylistUrl(subtitle.uri, masterPlaylistUrl)}]
            : []))
        .filter((subtitle, index, tracks) => tracks.findIndex(track => track._url === subtitle._url) === index);
}


export function updateVariantUriToFullUrls(masterPlaylist: types.MasterPlaylist, masterPlaylistUrl: string) {
    masterPlaylist.variants = masterPlaylist.variants.map(variant => ({
        ...variant,
        _url: getVariantPlaylistUrl(variant.uri, masterPlaylistUrl)
    }))
    masterPlaylist._url = masterPlaylistUrl;
    return masterPlaylist
}
